import { render } from "./ContactControlMessageForm.vue?vue&type=template&id=6846e152"
import script from "./ContactControlMessageForm.vue?vue&type=script&lang=js"
export * from "./ContactControlMessageForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__